import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FATAL_ERROR_NOTICE_TYPES } from '@kallidus/common';
import ErrorPage from '../ErrorBoundaryPages/ErrorPage';
import { useHistory } from 'react-router-dom';

export default function BadNavigationPage() {
  const { t } = useTranslation();
  const history = useHistory();
  const buttons = useMemo(
    () => [
      {
        label: t('error-page.go-home'),
        isPrimary: true,
        onClick: () => {
          history.push('/');
          // force page refresh to clear error state
          history.go(0);
        },
      },
    ],
    [history, t],
  );
  return (
    <ErrorPage
      subHeading={t('bad-navigation-page.heading')}
      type={FATAL_ERROR_NOTICE_TYPES.FORBIDDEN}
      message={t('bad-navigation-page.title')}
      buttons={buttons}
    />
  );
}
